!(function (t) {
	var e = {};
	function n(a) {
		if (e[a]) return e[a].exports;
		var i = (e[a] = { i: a, l: !1, exports: {} });
		return t[a].call(i.exports, i, i.exports, n), (i.l = !0), i.exports;
	}
	(n.m = t),
		(n.c = e),
		(n.d = function (t, e, a) {
			n.o(t, e) ||
				Object.defineProperty(t, e, { enumerable: !0, get: a });
		}),
		(n.r = function (t) {
			"undefined" != typeof Symbol &&
				Symbol.toStringTag &&
				Object.defineProperty(t, Symbol.toStringTag, {
					value: "Module",
				}),
				Object.defineProperty(t, "__esModule", { value: !0 });
		}),
		(n.t = function (t, e) {
			if ((1 & e && (t = n(t)), 8 & e)) return t;
			if (4 & e && "object" == typeof t && t && t.__esModule) return t;
			var a = Object.create(null);
			if (
				(n.r(a),
				Object.defineProperty(a, "default", {
					enumerable: !0,
					value: t,
				}),
				2 & e && "string" != typeof t)
			)
				for (var i in t)
					n.d(
						a,
						i,
						function (e) {
							return t[e];
						}.bind(null, i)
					);
			return a;
		}),
		(n.n = function (t) {
			var e =
				t && t.__esModule
					? function () {
							return t.default;
					  }
					: function () {
							return t;
					  };
			return n.d(e, "a", e), e;
		}),
		(n.o = function (t, e) {
			return Object.prototype.hasOwnProperty.call(t, e);
		}),
		(n.p = ""),
		n((n.s = 0));
})([
	function (t, e, n) {
		"use strict";
		n.r(e);
		n(1);
		function a() {
			var t = !1;
			$(document).on("click", ".burger", function (e) {
				e.preventDefault(),
					(t = (function (t) {
						(function (t) {
							var e = $("#site-navigation li").length,
								n = 0,
								a = "#site-navigation ul#primary-menu > li";
							if (!1 === t)
								var i = setInterval(function () {
										$(a).eq(n).addClass("item-show"),
											++n === e && clearInterval(i);
									}, 50),
									o = setInterval(function () {
										$(".login-mobile").addClass(
											"item-show"
										),
											clearInterval(o);
									}, 50 * e);
							else
								$(a).removeClass("item-show"),
									$(".login-mobile").removeClass("item-show");
						})(t),
							!1 === t
								? ($("body").addClass("menu-active"), (t = !0))
								: ($("body").removeClass("menu-active"),
								  (t = !1));
						return t;
					})(t));
			}),
				$(document).on("click", ".menu-overlay", function () {
					$("body").removeClass("menu-active");
				});
		}
		function i() {
			if (!$("body.single-product").length) {
				var t = $("header").height();
				$(window).scroll(function () {
					$(window).scrollTop() > t
						? $("body").addClass("menu-scroll")
						: $("body").removeClass("menu-scroll");
				}),
					$(window).scrollTop() > t
						? $("body").addClass("menu-scroll")
						: $(".menu-active").length ||
						  $("body").removeClass("menu-scroll");
			}
		}
		function o() {
			$("li.menu-item-has-children").each(function () {
				$(this).find(".toggle-children").length ||
					$("> a", this).append(
						'<span class="toggle-children"></span>'
					);
			});
			var t = !1;
			$(document).on("click", "span.toggle-children", function (e) {
				e.preventDefault(),
					t
						? ((t = !1),
						  $(this).removeClass("toggle-active"),
						  $(this).parent("a").siblings("ul.sub-menu").slideUp())
						: ((t = !0),
						  $(this).addClass("toggle-active"),
						  $(this)
								.parent("a")
								.siblings("ul.sub-menu")
								.slideDown());
			});
		}
		function r() {
			if ($(window).width() > 425) {
				var t = new WOW({
						boxClass: "reveal-animate",
						animateClass: "visible-fade",
						offset: 85,
						mobile: !0,
						live: !0,
						scrollContainer: null,
					}),
					e = new WOW({
						boxClass: "reveal-animate-two",
						animateClass: "visible-fade",
						offset: 85,
						mobile: !0,
						live: !0,
						scrollContainer: null,
					}),
					n = new WOW({
						boxClass: "reveal-animate-three",
						animateClass: "visible-fade",
						offset: 85,
						mobile: !0,
						live: !0,
						scrollContainer: null,
					}),
					a = new WOW({
						boxClass: "reveal-animate-four",
						animateClass: "visible-fade",
						offset: 85,
						mobile: !0,
						live: !0,
						scrollContainer: null,
					}),
					i = new WOW({
						boxClass: "reveal-animate-five",
						animateClass: "visible-fade",
						offset: 85,
						mobile: !0,
						live: !0,
						scrollContainer: null,
					});
				t.init(), e.init(), n.init(), a.init(), i.init();
			}
		}
		function s() {
			if ($(".rellax").length)
				new Rellax(".rellax", {
					speed: -2,
					center: !1,
					wrapper: null,
					round: !0,
					vertical: !0,
					horizontal: !1,
				});
		}
		function c() {
			if (
				((Flickity.prototype._touchActionValue = "pan-y pinch-zoom"),
				$(".main-carousel").length)
			) {
				var t = $(".main-carousel").flickity({
					prevNextButtons: !0,
					lazyLoad: 1,
					wrapAround: !0,
					pageDots: 1,
					setGallerySize: !0,
					freeScroll: !1,
					contain: !0,
					arrowShape: {
						x0: 10,
						x1: 85,
						y1: 45,
						x2: 85,
						y2: 35,
						x3: 25,
					},
				});
				t.on("lazyLoad.flickity", function (t, e) {
					var n = t.target;
					$(n).addClass("loaded");
				}),
					t.on("change.flickity", function (t, e) {
						var n = $(t.target).find("video").data("handle"),
							a = $(t.target).find("video").hasClass(n);
						void 0 !== n &&
							!0 === a &&
							yall({ observeChanges: !0, lazyClass: n });
					});
			}
			$(".terms-slider").flickity({
				prevNextButtons: !0,
				pageDots: !1,
				cellAlign: "center",
				wrapAround: !0,
				autoPlay: 4500,
				pauseAutoPlayOnHover: !1,
				arrowShape: { x0: 10, x1: 85, y1: 45, x2: 85, y2: 35, x3: 25 },
			}),
				$("footer .center .menu").flickity({
					prevNextButtons: !1,
					pageDots: !1,
					cellAlign: "center",
					contain: !0,
				});
			if ($(".main-carousel-product").length)
				$(".main-carousel-product").flickity({
					prevNextButtons: !0,
					pageDots: !1,
					setGallerySize: !0,
					cellAlign: "left",
					contain: !0,
					watchCSS: !0,
					imagesLoaded: !0,
					arrowShape: {
						x0: 10,
						x1: 85,
						y1: 45,
						x2: 85,
						y2: 35,
						x3: 25,
					},
				});
		}
		function l() {
			if ($("body.template-collection").length) {
				var t = $(".products-on-page"),
					e = t.data("next-url"),
					n = $(".load-more__spinner"),
					a = n.data("loaded"),
					i = !0;
				$(window).scroll(function (o) {
					var r =
							$(document).height() -
							$("#shopify-section-footer").height(),
						s = $(window).scrollTop() + $(window).height() + 250;
					s >= r &&
						!0 === i &&
						"" !== e &&
						((i = !1),
						$.ajax({
							url: e,
							type: "GET",
							dataType: "html",
							beforeSend: function () {
								n.show();
							},
						}).done(function (o) {
							n.hide();
							var r = $(o).find(".products-on-page");
							(e = r.data("next-url")).length ||
								$(".load-more").html("<h6>" + a + "</h6>"),
								t.append(r.html()),
								c(),
								(i = !0);
						}));
				});
			}
		}
		function d() {
			$(document).on("click", ".accordion .top", function (t) {
				$(this).parents(".accordion").hasClass("show")
					? $(this).parents(".accordion").removeClass("show")
					: $(this).parents(".accordion").addClass("show");
			});
		}
		function u() {
			$(document).on("click", "header form.search .icon", function () {
				$("header form.search input.input-search")
					.toggleClass("active")
					.focus();
			});
		}
		function h() {
			$("#days").length &&
				$("#hours").length &&
				$("#minutes").length &&
				setInterval(function () {
					!(function () {
						var t = $("section.password-bf").data("date"),
							e = new Date(t);
						e = Date.parse(e) / 1e3;
						var n = new Date(),
							a = e - (n = Date.parse(n) / 1e3),
							i = Math.floor(a / 86400),
							o = Math.floor((a - 86400 * i) / 3600),
							r = Math.floor((a - 86400 * i - 3600 * o) / 60),
							s = Math.floor(a - 86400 * i - 3600 * o - 60 * r);
						o < "10" && (o = "0" + o),
							r < "10" && (r = "0" + r),
							s < "10" && (s = "0" + s),
							$("#days span.number").html(i),
							$("#hours span.number").html(o),
							$("#minutes span.number").html(r),
							$("#seconds span.number").html(s);
					})();
				}, 1e3);
		}
		(window.slate = window.slate || {}),
			(window.theme = window.theme || {}),
			(slate.Sections = function () {
				(this.constructors = {}),
					(this.instances = []),
					$(document)
						.on(
							"shopify:section:load",
							this._onSectionLoad.bind(this)
						)
						.on(
							"shopify:section:unload",
							this._onSectionUnload.bind(this)
						)
						.on("shopify:section:select", this._onSelect.bind(this))
						.on(
							"shopify:section:deselect",
							this._onDeselect.bind(this)
						)
						.on(
							"shopify:section:reorder",
							this._onReorder.bind(this)
						)
						.on(
							"shopify:block:select",
							this._onBlockSelect.bind(this)
						)
						.on(
							"shopify:block:deselect",
							this._onBlockDeselect.bind(this)
						);
			}),
			(slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
				_createInstance: function (t, e) {
					var n = $(t),
						a = n.attr("data-section-id"),
						i = n.attr("data-section-type");
					if (void 0 !== (e = e || this.constructors[i])) {
						var o = $.extend(new e(t), {
							id: a,
							type: i,
							container: t,
						});
						this.instances.push(o);
					}
				},
				_onSectionLoad: function (t) {
					var e = $("[data-section-id]", t.target)[0];
					e && this._createInstance(e);
				},
				_onSectionUnload: function (t) {
					var e = slate.utils.findInstance(
						this.instances,
						"id",
						t.detail.sectionId
					);
					e &&
						("function" == typeof e.onUnload && e.onUnload(t),
						(this.instances = slate.utils.removeInstance(
							this.instances,
							"id",
							t.detail.sectionId
						)));
				},
				_onSelect: function (t) {
					var e = slate.utils.findInstance(
						this.instances,
						"id",
						t.detail.sectionId
					);
					e && "function" == typeof e.onSelect && e.onSelect(t);
				},
				_onDeselect: function (t) {
					var e = slate.utils.findInstance(
						this.instances,
						"id",
						t.detail.sectionId
					);
					e && "function" == typeof e.onDeselect && e.onDeselect(t);
				},
				_onReorder: function (t) {
					var e = slate.utils.findInstance(
						this.instances,
						"id",
						t.detail.sectionId
					);
					e && "function" == typeof e.onReorder && e.onReorder(t);
				},
				_onBlockSelect: function (t) {
					var e = slate.utils.findInstance(
						this.instances,
						"id",
						t.detail.sectionId
					);
					e &&
						"function" == typeof e.onBlockSelect &&
						e.onBlockSelect(t);
				},
				_onBlockDeselect: function (t) {
					var e = slate.utils.findInstance(
						this.instances,
						"id",
						t.detail.sectionId
					);
					e &&
						"function" == typeof e.onBlockDeselect &&
						e.onBlockDeselect(t);
				},
				register: function (t, e) {
					(this.constructors[t] = e),
						$("[data-section-type=" + t + "]").each(
							function (t, n) {
								this._createInstance(n, e);
							}.bind(this)
						);
				},
			})),
			(slate.Image = {
				preload: function (t, e) {
					"string" == typeof t && (t = [t]);
					for (var n = 0; n < t.length; n++) {
						var a = t[n];
						this.loadImage(this.getSizedImageUrl(a, e));
					}
				},
				loadImage: function (t) {
					new Image().src = t;
				},
				imageSize: function (t) {
					var e = t.match(
						/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
					);
					return e ? e[1] : null;
				},
				getSizedImageUrl: function (t, e) {
					if (null === e) return t;
					if ("master" === e) return this.removeProtocol(t);
					var n = t.match(
						/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
					);
					if (n) {
						var a = t.split(n[0]),
							i = n[0];
						return this.removeProtocol(a[0] + "_" + e + i);
					}
					return null;
				},
				removeProtocol: function (t) {
					return t.replace(/http(s)?:/, "");
				},
			}),
			(theme.Product = (function () {
				var t = "[data-add-to-cart]",
					e = "[data-add-to-cart-text]",
                  
					n = "[data-compare-price]",
					a = "[data-compare-text]",
					i = "[data-product-select]",
					o = "[data-product-featured-image]",
					r = "[data-product-json]",
					s = "[data-product-price]",
					c = "[data-single-option-selector]",
					l = "[data-variant-inventory]",
					d = "[data-variant-inventory-wrapper]",
					u = "[data-notify-trigger]";

             
              
				function h(t) {
					if (((this.$container = $(t)), $(r, this.$container).html())) {
						this.$container.attr("data-section-id");
						this.productSingleObject = JSON.parse(
							$(r, this.$container).html()
						);
						var e = {
							$container: this.$container,
							enableHistoryState:
								this.$container.data("enable-history-state") ||
								!1,
							singleOptionSelector: c,
							originalSelectorId: i,
							product: this.productSingleObject,
						};
                      
						(this.settings = {}),
							(this.namespace = ".product"),
							(this.variants = new slate.Variants(e)),
							(this.$featuredImage = $(o, this.$container)),
							this.$container.on(
								"variantChange" + this.namespace,
								this.updateAddToCartState.bind(this)
							),
							this.$container.on(
								"variantPriceChange" + this.namespace,
								this.updateProductPrices.bind(this)
							),
							this.$featuredImage.length > 0 &&
								((this.settings.imageSize =
									slate.Image.imageSize(
										this.$featuredImage.attr("src")
									)),
								slate.Image.preload(
									this.productSingleObject.images,
									this.settings.imageSize
								),
								this.$container.on(
									"variantImageChange" + this.namespace,
									this.updateProductImage.bind(this)
								));
					}
				}
				return (
					(h.prototype = $.extend({}, h.prototype, {
						updateAddToCartState: function (n) {
							var a = n.variant;
                            console.log("a=================================>",a)
							if (!a || !a.available)
								return (
									$(t, this.$container)
										.prop("disabled", !0)
										.addClass("hide"),
									$(u, this.$container).removeClass("hide"),
									$(e, this.$container).text(
										theme.strings.soldOut
									),
									void $(d, this.$container).addClass("hide")
								);
							$(t, this.$container)
								.prop("disabled", !1)
								.removeClass("hide"),
								$(u, this.$container).addClass("hide"),
								$(e, this.$container).text(
									theme.strings.addToCart
								),
								$(d, this.$container).length &&
									($(l, this.$container).html(inv_qty[a.id]),
									inv_qty[a.id] <= 10
										? $(d, this.$container).removeClass(
												"hide"
										  )
										: $(d, this.$container).addClass(
												"hide"
										  ));
						},
						updateProductPrices: function (t) {
							var e = t.variant,
								i = $(n, this.$container),
								o = i.add(a, this.$container);
							$(s, this.$container).html(
								slate.Currency.formatMoney(
									e.price,
									theme.moneyFormat
								)
							),
								parseInt(e.compare_at_price) > parseInt(e.price)
									? (i.html(
											slate.Currency.formatMoney(
												e.compare_at_price,
												theme.moneyFormat
											)
									  ),
									  i.parent().addClass("sale-price"),
									  o.removeClass("hide"))
									: (i.parent().removeClass("sale-price"),
									  i.html(""),
									  o.addClass("hide"));
						},
						updateProductImage: function (t) {
							var e = t.variant,
								n = slate.Image.getSizedImageUrl(
									e.featured_image.src,
									this.settings.imageSize
								);
							this.$featuredImage.attr("src", n);
						},
						onUnload: function () {
							this.$container.off(this.namespace);
						},
                      updateProductPrices: function (z) {
							var e = t.variant,
								i = $(n, this.$container),
								o = i.add(a, this.$container);
							$(s, this.$container).html(
								slate.Currency.formatMoney(
									e.price,
									theme.moneyFormat
								)
							),
								parseInt(e.compare_at_price) > parseInt(e.price)
									? (i.html(
											slate.Currency.formatMoney(
												e.compare_at_price,
												theme.moneyFormat
											)
									  ),
									  i.parent().addClass("sale-price"),
									  o.removeClass("hide"))
									: (i.parent().removeClass("sale-price"),
									  i.html(""),
									  o.addClass("hide"));
						},
						updateProductImage: function (z) {
							var e = t.variant,
								n = slate.Image.getSizedImageUrl(
									e.featured_image.src,
									this.settings.imageSize
								);
							this.$featuredImage.attr("src", n);
						},
						onUnload: function () {
							this.$container.off(this.namespace);
						},
					})),
					h
				);
			})()),
			(slate.utils = {
				findInstance: function (t, e, n) {
					for (var a = 0; a < t.length; a++)
						if (t[a][e] === n) return t[a];
				},
				removeInstance: function (t, e, n) {
					for (var a = t.length; a--; )
						if (t[a][e] === n) {
							t.splice(a, 1);
							break;
						}
					return t;
				},
				compact: function (t) {
					for (
						var e = -1, n = null == t ? 0 : t.length, a = 0, i = [];
						++e < n;

					) {
						var o = t[e];
						o && (i[a++] = o);
					}
					return i;
				},
				defaultTo: function (t, e) {
					return null == t || t != t ? e : t;
				},
			}),

          (slate.utils = {
				findInstance: function (t, e, n) {
					for (var a = 0; a < t.length; a++)
						if (t[a][e] === n) return t[a];
				},
				removeInstance: function (t, e, n) {
					for (var a = t.length; a--; )
						if (t[a][e] === n) {
							t.splice(a, 1);
							break;
						}
					return t;
				},
				compact: function (t) {
					for (
						var e = -1, n = null == t ? 0 : t.length, a = 0, i = [];
						++e < n;

					) {
						var o = t[e];
						o && (i[a++] = o);
					}
					return i;
				},
				defaultTo: function (t, e) {
					return null == t || t != t ? e : t;
				},
			}),
          
			(slate.Variants = (function () {
				function t(t) {
					(this.$container = t.$container),
						(this.product = t.product),
						(this.singleOptionSelector = t.singleOptionSelector),
						(this.originalSelectorId = t.originalSelectorId),
						(this.enableHistoryState = t.enableHistoryState),
						(this.currentVariant = this._getVariantFromOptions()),
						$(this.singleOptionSelector, this.$container).on(
							"change",
							this._onSelectChange.bind(this)
						);
				}
				return (
					(t.prototype = $.extend({}, t.prototype, {
						_getCurrentOptions: function () {
							var t = $.map(
								$(this.singleOptionSelector, this.$container),
								function (t) {
									var e = $(t),
										n = e.attr("type"),
										a = {};
                                   
									return "radio" === n || "checkbox" === n
										? !!e[0].checked &&
												((a.value = e.val()),
												(a.index = e.data("index")),
												a)
										: ((a.value = e.val()),
										  (a.index = e.data("index")),
										  a);
								}
							);
							return (t = slate.utils.compact(t));
						},
						_getVariantFromOptions: function () {
							var t = this._getCurrentOptions(),
								e = this.product.variants,
								n = !1;

                          console.log("t========_getVariantFromOptions==========>",t);
                          console.log("e========_getVariantFromOptions==========>",e);
                          
                           var lent=t.length;
                           if(lent == 4){
                             t.pop();
                             t.pop();
                           }
                          
							return (
								e.forEach(function (ee) {
									var a = !0;
									t.forEach(function (tt) {
										a && (a = (tt.value === ee[tt.index]));
									}),
										a && (n = ee);
								}),
								n || null
							);
						},
						_onSelectChange: function () {
							var t = this._getVariantFromOptions();
                            console.log("t========_onSelectChange==========>",t);
                          
							this.$container.trigger({
								type: "variantChange",
								variant: t,
							}),
								t &&
									(this._updateMasterSelect(t),
									this._updateImages(t),
									this._updatePrice(t),
									(this.currentVariant = t),
									this.enableHistoryState &&
										this._updateHistoryState(t));
						},
						_updateImages: function (t) {
							var e = t.featured_image || {},
								n = this.currentVariant.featured_image || {};
							t.featured_image &&
								e.src !== n.src &&
								this.$container.trigger({
									type: "variantImageChange",
									variant: t,
								});
						},
						_updatePrice: function (t) {
							(t.price === this.currentVariant.price &&
								t.compare_at_price ===
									this.currentVariant.compare_at_price) ||
								this.$container.trigger({
									type: "variantPriceChange",
									variant: t,
								});
						},
						_updateHistoryState: function (t) {
							if (history.replaceState && t) {
								var e =
									window.location.protocol +
									"//" +
									window.location.host +
									window.location.pathname +
									"?variant=" +
									t.id;
								window.history.replaceState({ path: e }, "", e);
							}
						},
						_updateMasterSelect: function (t) {
							$(
								this.originalSelectorId,
								this.$container
							)[0].value = t.id;
						},
					})),
					t
				);
			})()),
			(slate.Currency = {
				formatMoney: function (t, e) {
					"string" == typeof t && (t = t.replace(".", ""));
					var n = "",
						a = /\{\{\s*(\w+)\s*\}\}/,
						i = e || "${{amount}}";
					function o(t, e, n, a) {
						return (
							(e = slate.utils.defaultTo(e, 2)),
							(n = slate.utils.defaultTo(n, ",")),
							(a = slate.utils.defaultTo(a, ".")),
							isNaN(t) || null == t
								? 0
								: (t = (t / 100).toFixed(e))
										.split(".")[0]
										.replace(
											/(\d)(?=(\d\d\d)+(?!\d))/g,
											"$1" + n
										)
						);
					}
					switch (i.match(a)[1]) {
						case "amount":
							n = o(t, 2);
							break;
						case "amount_no_decimals":
							n = o(t, 0);
							break;
						case "amount_with_comma_separator":
							n = o(t, 2, ".", ",");
							break;
						case "amount_no_decimals_with_comma_separator":
							n = o(t, 0, ".", ",");
					}
					return i.replace(a, n);
				},
			}),
			jQuery(function (t) {
				t(document).ready(function () {
					new slate.Sections().register("product", theme.Product),
						a(),
						i(),
						r(),
						o(),
						s(),
						c(),
						l(),
						d(),
						u(),
						h();
				});
			});
	},
	function (t, e, n) {},
]);

// Add an event listener to the button with class 'show-onhide'
document.querySelector('.show-onhide').addEventListener('click', function() {
    
    // Show the div with class 'on-hide-then-show'
    document.querySelector('.on-hide-then-show').style.display = 'block';
    
    // Hide the button with class 'show-onhide'
    this.style.display = 'none';
    
    // Show the button with class 'me-btn-add'
    document.querySelector('.me-btn-add').style.display = 'inline-block';
});

// Add an event listener to the document to detect clicks outside the elements
document.addEventListener('click', function(event) {
    // Elements to target
    const meBtnAdd = document.querySelector('.me-btn-add');
    const onHideThenShow = document.querySelector('.on-hide-then-show');
    const showOnHide = document.querySelector('.show-onhide');

    // Check if the clicked element is outside the targeted elements
    if (!meBtnAdd.contains(event.target) && !onHideThenShow.contains(event.target) && !showOnHide.contains(event.target)) {
        
        // Hide the 'me-btn-add' and 'on-hide-then-show' elements
        meBtnAdd.style.display = 'none';
        onHideThenShow.style.display = 'none';

        // Show the 'show-onhide' button again
        showOnHide.style.display = 'inline-block';
    }
});

// Add an event listener to the div with class 'close' to hide elements when clicked
document.querySelector('.close-box').addEventListener('click', function() {
    // Target the elements
    const meBtnAdd = document.querySelector('.me-btn-add');
    const onHideThenShow = document.querySelector('.on-hide-then-show');
    const showOnHide = document.querySelector('.show-onhide');

    // Hide the 'me-btn-add' and 'on-hide-then-show' elements
    meBtnAdd.style.display = 'none';
    onHideThenShow.style.display = 'none';

    // Show the 'show-onhide' button again
    showOnHide.style.display = 'inline-block';
});

// Add an event listener to the window to detect scroll
window.addEventListener('scroll', function() {
    // Target the elements
    const lkkotopTop = document.querySelector('.lkkotop-top');
    const mainTopWrap = document.querySelector('.main-top-wrap');
    const productImages = document.querySelector('.product-images');

   const main_variant_options = document.getElementById('main-variant-options');

    // Find the height of the 'product-images' div
    const productImagesHeight = productImages ? productImages.offsetHeight : 0;

    // Set the scroll threshold to productImagesHeight + 500px
    const scrollThreshold = productImagesHeight - 500;

    // Check if the window is scrolled beyond the threshold

  var isMobile = Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1;
  
  console.log("isMobile=========================>",isMobile)
  if(isMobile){
    const main_variant_options_Height = main_variant_options ? main_variant_options.offsetHeight : 0;
    const main_variant_options_scrollThreshold = main_variant_options_Height+480;

    if (window.scrollY > main_variant_options_scrollThreshold) {
        // Hide the div with class 'lkkotop-top'
        lkkotopTop.style.display = 'none';

        // Show the div with class 'main-top-wrap'
        mainTopWrap.style.display = 'block';
    } else {
        // Show the 'lkkotop-top' and hide 'main-top-wrap' if not scrolled beyond the threshold
        lkkotopTop.style.display = 'block';
        mainTopWrap.style.display = 'none';
    }
    
  }else{
   
    if (window.scrollY > scrollThreshold) {
        // Hide the div with class 'lkkotop-top'
        lkkotopTop.style.display = 'none';

        // Show the div with class 'main-top-wrap'
        mainTopWrap.style.display = 'block';
    } else {
        // Show the 'lkkotop-top' and hide 'main-top-wrap' if not scrolled beyond the threshold
        lkkotopTop.style.display = 'block';
        mainTopWrap.style.display = 'none';
    }
  }
});


// // Function to check if an element is in the viewport
// function isInViewport(element) {
//     const rect = element.getBoundingClientRect();
//     return (
//         rect.top >= 0 &&
//         rect.left >= 0 &&
//         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
//         rect.right <= (window.innerWidth || document.documentElement.clientWidth)
//     );
// }

// // Function to show the div if it's not visible
// function showDivIfNotVisible(divId) {
//     const div = document.getElementById(divId);
//     if (!isInViewport(div)) {
//         div.style.display = 'block';  // Show the div
//     } else {
//         div.style.display = 'none';   // Optionally, hide the div if it's already visible
//     }
// }

// // Call the function and pass the ID of the div you want to check
// window.addEventListener('scroll', function() {
//     showDivIfNotVisible('scroll-variant-options');
// });

// // You can also trigger the check on window resize or other events if needed
// window.addEventListener('resize', function() {
//     showDivIfNotVisible('scroll-variant-options');
// });

